import { postWithToken } from '~/code/services'
import { ConfigStore } from '~/code/config'

export function validateApplePaySession (url, displayName, merchantId?, domainName?) {
    return postWithToken(`${ ConfigStore.getUrl().apiUrl }/v1/applepay/session`, { url, displayName, merchantId, domainName})
}
